import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { BillingType, BILLING_TYPE_LABELS, BUDGET_STATE } from 'domain/shared/newProject';
import { Box } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';

const BillingTypeField = ({ source, isPrestart, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper<BillingType>({ source });
  const { getValue: getPrestartState } = useFieldHelper({ source: isPrestart });
  const billingType = getValue();

  return (
    <Box gap={2} display="flex">
      <TextField {...props} value={BILLING_TYPE_LABELS[billingType] || billingType || ''} label="" />
      <Badge color="default" isVisible={getPrestartState() === BUDGET_STATE.INIT}>
        Pre-start
      </Badge>
    </Box>
  );
};

export default BillingTypeField;
